// 配置全局接口域名
const domain = 'https://www.flcccc.com/';
const partyDomain = window.domainName;
const ajaxUrl = 'flow/';

const dataRealization = 'flow/flowSystem/'


// const ajaxUrl='';


export default {
	testUrl: domain,
	dataRealization,
	ajaxUrl,
	partyDomain
}